import {
  DirectorioContacto,
  DirectorioCategoria,
  DirectorioResponse,
} from "./types/directorio";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

interface ContactoRaw {
  id: number;
  nombre: string;
  telefono: string;
  correo: string;
  categoria: {
    id: number;
    nombre: string;
  };
}

export async function fetchDirectorio(
  lang: Locale
): Promise<DirectorioResponse> {
  const res = await fetchWithRetry<{ data: ContactoRaw[] }>(
    `/contactos?lang=${cmsLang(lang)}`
  );

  // Mapear contactos
  const contactos: DirectorioContacto[] = res.data.map((item) => ({
    id: item.id,
    nombre: item.nombre,
    telefono: item.telefono,
    correo: item.correo,
    categoria: {
      id: item.categoria.id,
      nombre: item.categoria.nombre,
    },
  }));

  // Extraer categorías únicas
  const categoriasMap = new Map<number, DirectorioCategoria>();
  res.data.forEach((item) => {
    if (!categoriasMap.has(item.categoria.id)) {
      categoriasMap.set(item.categoria.id, {
        id: item.categoria.id,
        nombre: item.categoria.nombre,
        nombreKey: item.categoria.nombre.toLowerCase().trim(),
      });
    }
  });

  const categorias = Array.from(categoriasMap.values());

  return {
    contactos,
    categorias,
  };
}
